import { render, staticRenderFns } from "./AssessmentPeriodsList.vue?vue&type=template&id=0b33cd6c"
import script from "./assessment-periods-list.ts?vue&type=script&lang=ts&external"
export * from "./assessment-periods-list.ts?vue&type=script&lang=ts&external"
import style0 from "./assessment-periods-list.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports